import { CaseFileContext } from "./CaseFileContext";
import { useContext } from "react";

export function useCaseFileContext() {
    const context = useContext(CaseFileContext);
    if (!context) {
        throw new Error('useCaseFileContext must be used within a CaseFileProvider');
    }
    return context;
}
